module.exports = __webpack_public_path__ + "img/privacy.1fe1c3d2.jpg";